export default __webpack_public_path__ + "static/media/neoronio-inactive.6e4fcb94.svg";